<!-- @format -->

<ng-container *transloco="let t">
  <sis-description-list>
    <ng-template #listItem>
      <dt>{{ t("MODULE_INFO.TITLE_CODE_NAME") }}</dt>
      <dd>{{ _module?.code }} </dd>
      <dd>{{ _module?.name | localizedString }}</dd>
    </ng-template>
    @if (isStudyModule(_module)) {
      <ng-template #listItem>
        <dt>{{ t("MODULE_INFO.TITLE_STUDY_LEVEL") }}</dt>
        <dd>{{ _module.studyLevel | codeLocalizedName | async }}</dd>
      </ng-template>
    }
    @if (_module?.gradeScaleId) {
      <ng-template>
        <dt>{{ t("MODULE_INFO.TITLE_GRADE_SCALE") }}</dt>
        <dd>{{ (_module.gradeScaleId | gradeScale | async)?.name | localizedString }}</dd>
      </ng-template>
    }
    @if (_module?.targetCredits) {
      <ng-template #listItem>
        <dt>{{ t("MODULE_INFO.TITLE_CREDIT_RANGE") }} ({{ t("MODULE_INFO.CREDITS_ABBREVIATION") }})</dt>
        <dd>{{ _module.targetCredits | creditRange: "TEXT" : true }}</dd>
      </ng-template>
    }
    @if (_module?.curriculumPeriodIds?.length > 0) {
      <ng-template #listItem>
        <dt>{{ t("MODULE_INFO.TITLE_CURRICULUMPERIOD") }}</dt>
        @for (curriculumPeriod of sortedCurriculumPeriods$ | async; track curriculumPeriod) {
          <dd>{{ curriculumPeriod.abbreviation | localizedString }}</dd>
        }
        <dd></dd>
      </ng-template>
    }
    @if (isDegreeProgramme(_module) && _module.educationClassificationUrns?.length > 0) {
      <ng-template #listItem>
        <dt>{{ t("MODULE_INFO.TITLE_EDUCATION_CLASSIFICATION") }}</dt>
        @for (educationClassificationUrn of _module.educationClassificationUrns; track educationClassificationUrn) {
          <dd>{{ educationClassificationUrn | codeLocalizedName | async }}</dd>
        }
      </ng-template>
    }
    @if (validResponsibilityInfos$ | async; as validResponsibilityInfos) {
      @if (validResponsibilityInfos?.length > 0) {
        <ng-template #listItem>
          <dt>{{ t("MODULE_INFO.TITLE_RESPONSIBILITY_INFOS") }}</dt>
          @for (responsibilityInfo of validResponsibilityInfos; track responsibilityInfo) {
            <dd>
              {{ responsibilityInfo.roleUrn | codeLocalizedName | async }}:
              @if (responsibilityInfo?.personId | publicPerson | async; as person) {
                {{ person | personFullName }}{{ person.emailAddress ? ", " : "" }}{{ person.emailAddress }}
              }
              @if (responsibilityInfo.text | localizedString; as responsibilityInfoText) {
                {{ responsibilityInfo?.personId ? ", " : "" }}{{ responsibilityInfoText }}
              }
              @if (responsibilityInfo.validityPeriod | dateRangeDisplay; as validityPeriod) {
                , {{ validityPeriod }}
              }
            </dd>
          }
        </ng-template>
      }
    }
    @if (_module?.universityOrgIds?.length > 0) {
      <ng-template #listItem>
        <dt>{{ t("MODULE_INFO.TITLE_UNIVERSITIES") }}</dt>
        @for (universityId of _module?.universityOrgIds; track universityId) {
          <dd>{{ (universityId | organisation | async)?.name | localizedString }}</dd>
        }
      </ng-template>
    }
    <ng-template #listItem>
      <dt>{{ t("MODULE_INFO.TITLE_RESPONSIBLE_ORGANISATIONS") }}</dt>
      <dd>
        <sis-organisation-role-share
          [organisations]="_module?.organisations"
          [organisationRoleUrn]="'urn:code:organisation-role:responsible-organisation'"
          [hideLabel]="true">
        </sis-organisation-role-share>
      </dd>
    </ng-template>
    @if (_module?.organisations | hasOrganisationRole: "urn:code:organisation-role:coordinating-organisation") {
      <ng-template #listItem>
        <dt>{{ t("MODULE_INFO.TITLE_COORDINATING_ORGANISATIONS") }}</dt>
        <dd>
          <sis-organisation-role-share
            [organisations]="_module?.organisations"
            [organisationRoleUrn]="'urn:code:organisation-role:coordinating-organisation'"
            [hideLabel]="true">
          </sis-organisation-role-share>
        </dd>
      </ng-template>
    }
  </sis-description-list>
</ng-container>
